import {
  PageFooterVolunteeringLinksHolder,
  PageFooterVolunteeringLinksItem,
  PageFooterVolunteeringLinksList,
  PageFooterVolunteeringLinksTitle,
} from '#/components/PageFooter/VolunteeringLinks/PageFooterVolunteeringLinks.styled';
import { pageFooterVolunteeringLinksData } from '#/components/PageFooter/VolunteeringLinks/pageFooterVolunteeringLinksData';
import { trackClicked } from '#/utils/analytics/track/trackClicked';

export function PageFooterVolunteeringLinks() {
  return (
    <PageFooterVolunteeringLinksHolder>
      <PageFooterVolunteeringLinksTitle>
        Local Volunteer Opportunities
      </PageFooterVolunteeringLinksTitle>

      <PageFooterVolunteeringLinksList>
        {pageFooterVolunteeringLinksData.map((data) => (
          <PageFooterVolunteeringLinksItem
            key={data.title}
            to={data.href}
            onClick={() => {
              trackClicked('Local Volunteer Opp', {
                url: data.href,
                context: 'Footer',
              });
            }}
          >
            {data.title}
          </PageFooterVolunteeringLinksItem>
        ))}
      </PageFooterVolunteeringLinksList>
    </PageFooterVolunteeringLinksHolder>
  );
}
